import styled from "styled-components";
import { Tabs } from "antd";

export const StyledTabs = styled(Tabs)`

  height: 100%;
  display: flex;
  flex-direction: column;

  .ant-tabs-content-holder {
    flex: 1;
    overflow: auto;
  }

  .ant-tabs-nav {
    margin: 0;
    width: 100%;
  }

  .ant-tabs-nav-list {
    width: 100%;
    display: flex;
  }

  .ant-tabs-content-holder {
    .ant-tabs-content {
      height: 100%;
    }
  }

  .ant-tabs-tabpane {
    height: 100%;
  }

  .ant-tabs-tab {
    flex: 1;
    justify-content: center;
    text-align: center;
    padding: 12px 0;
    font-weight: 400;
    font-size: 14px;
    color: #5b5b5b;
    transition: all 0.3s;
    font-family: 'Manrope', sans-serif;
    &:hover {
      color: #0C53BB; /* or your desired hover color */
    }
  }

  .ant-tabs-tab:focus,
  .ant-tabs-tab:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  .ant-tabs-tab div {
    outline: none !important;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
    font-weight: 600;
    color: #0C53BB!important;
    }
  }

  .ant-tabs-ink-bar {
    background: #0C53BB;
    height: 1px;
    transition: all 0.3s;
  }
`;
